// extracted by mini-css-extract-plugin
export default {"modalContent":"Modal_modalContent__X-r2u","modalBody":"Modal_modalBody__2qTTJ"};